import { pick } from 'lodash-es';
import { useApi2call } from 'containers/Api2/index.js';
import messages from '../Planner/messages.js';

const SLOT_FIELDS = ['id', 'start', 'end', 'status', 'blockId', 'meetingId', 'timestamp', 'notes'];

function useSaveTimeslots() {
  const api2call = useApi2call();
  function saveTimeslots(setId, slots, props) {
    const options = {
      method: 'POST',
      url: `meetings/sets/${setId}/timeslots`,
      selector: `meetings/sets/${setId}/blocks`,
      body: { timeslots: slots.map((slot) => pick(slot, SLOT_FIELDS)) },
      ...props,
      withPromise: true,
    };
    return api2call(options);
  }
  function updateTimeslot(setId, slot, props) {
    const options = {
      method: 'PUT',
      url: `meetings/sets/${setId}/timeslots/${slot.id}`,
      selector: `meetings/sets/${setId}/blocks`,
      body: pick(slot, SLOT_FIELDS),
      error: { 409: messages.timeslotGone, 410: messages.timeslotGone },
      noReport: [409, 410],
      ...props,
      withPromise: true,
    };
    return api2call(options);
  }
  return { saveTimeslots, updateTimeslot };
}

export default useSaveTimeslots;
